import { render, staticRenderFns } from "./SimulationDetailSinglePlotsList.vue?vue&type=template&id=4e5bd932"
import script from "./SimulationDetailSinglePlotsList.vue?vue&type=script&lang=ts"
export * from "./SimulationDetailSinglePlotsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports